<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm6 md4 lg3>
      <v-card class="elevation-12" align-center justify-center>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Login</v-toolbar-title>
        </v-toolbar>
        <v-card xs12 class="d-flex justify-center pa-4">
          <v-img :src="logo" max-width="250"></v-img>
        </v-card>
        <v-card-text>
          <v-form>
            <v-text-field
              prepend-icon="email"
              name="email"
              label="Email"
              type="email"
              v-model="email"
              :error-messages="emailErrors"
              @input="$v.email.$touch()"
              @blur="$v.email.$touch()"
              @keyup.enter="login"
            ></v-text-field>
            <v-text-field
              :append-icon="showpassword ? 'visibility_off' : 'visibility'"
              prepend-icon="lock"
              name="password"
              label="Password"
              id="password"
              :type="showpassword ? 'text' : 'password'"
              v-model="password"
              :error-messages="passwordErrors"
              @input="$v.password.$touch()"
              @blur="$v.password.$touch()"
              @keyup.enter="login"
              @click:append="() => (showpassword = !showpassword)"
            ></v-text-field>
          </v-form>
          <v-alert :value="error" type="warning" transition="scale-transition">
            <span v-html="error"></span>
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn flat color="primary" to="/forgot_password">Forgot Password</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="login">Login</v-btn>
        </v-card-actions>
      </v-card>
      <v-card xs12 class="d-flex justify-center pa-4">
        <v-img :src="ride" max-width="150"></v-img>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import AuthenticationService from '@/services/AuthenticationService'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import moment from 'moment'

export default {
  mixins: [validationMixin],

  validations: {
    email: { required, email },
    password: { required }
  },

  data () {
    return {
      showpassword: false,
      email: '',
      password: '',
      error: null,
      logo: '',
      ride: ''
    }
  },

  created () {
    this.getLogo()
  },

  computed: {
    passwordErrors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('Password is required.')
      return errors
    },
    emailErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Must be valid e-mail')
      !this.$v.email.required && errors.push('E-mail is required')
      return errors
    }
  },

  methods: {
    async getLogo () {
      const response = await Api().get('get_logo')

      this.logo = 'data:image/jpeg;base64,' + response.data.logo
      this.ride = 'data:image/jpeg;base64,' + response.data.ride
    },

    async login () {
      this.$v.$touch()

      try {
        const response = await AuthenticationService.login({
          email: this.email,
          password: this.password
        })
        let userControl = []
        let currentDate = moment().format('YYYY-MM-DD')
        let theDate = moment().toObject()

        for (let i in response.data.user.UserControls) {
          userControl.push(response.data.user.UserControls[i].Control.name)
        }
        console.log(response.data.user)

        if (currentDate >= theDate.years + '-09-01') {
          this.$store.dispatch('setCurrentYear', theDate.years + 1)
        } else {
          this.$store.dispatch('setCurrentYear', theDate.years)
        }

        this.$store.dispatch('setToken', response.data.token)
        this.$store.dispatch('setUser', response.data.user)
        this.$store.dispatch('setControl', userControl)
        this.$store.dispatch('setLogo', this.logo)

        // if (!response.data.user.handBook) {
        //   this.$router.push({
        //     name: 'liability'
        //   })
        // } else {
        this.$router.push({
          name: 'dashboard'
        })
        // }
      } catch (error) {
        this.error = error.response.data.error
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Login.vue